<div>
	<div class="content-header" fxLayout="row" fxLayoutAlign="space-between center">
		<button (click)="refreshFiles()" id="refreshButton" class="refresh-button" mat-icon-button>
			<app-icon
				id="refresh-icon"
				[name]="'rotate-right'"
				[color]="'var(--color-disabled)'"
				[lineWidth]="'2px'"
				[size]="'28'"
			></app-icon>
		</button>

		<div class="button-container">
			<ng-template
				[appUserRolePermissions]
				[action]="'show'"
				[roles]="['SUPER_ADMIN', 'TS_OPERATION_CONSULTANT', 'TS_OPERATION_LEAD']"
			>
				<button id="integrationBtn" class="integration-btn" mat-button (click)="runPayrollIntegration()">
					<app-icon
						class="integrate-icon"
						[name]="'receipt-add'"
						[color]="'var(--color-filter-button)'"
						[lineWidth]="'1.5px'"
					></app-icon>

					<span class="integration-label-color">PAYROLL INTEGRATION</span>
				</button>
			</ng-template>

			<ng-template
				[appUserRolePermissions]
				[action]="'show'"
				[roles]="[
					'SUPER_ADMIN',
					'TS_IMPLEMENTATION_CONSULTANT',
					'TS_OPERATION_CONSULTANT',
					'TS_OPERATION_LEAD'
				]"
			>
				@if (!isPaymentDeductionEnabled) {
				<button id="uploadBtnG2n" class="upload-btn-g2n" mat-raised-button (click)="fileClick()">
					<span class="uploadText">
						<app-icon
							id="add-g2n-file-history"
							[name]="'document-upload'"
							[color]="'var(--color-white)'"
							[lineWidth]="'2px'"
						></app-icon>
						<span class="text-spacing">UPLOAD G2N FILE</span>
					</span>
				</button>
				} @else {
				<button
					class="payment-order-button"
					[cdkMenuTriggerFor]="menu"
					mat-button
					(cdkMenuClosed)="paymentOrderDropdown = false"
					(cdkMenuOpened)="paymentOrderDropdown = true"
					[attr.data-test]="'payment-orders-button'"
				>
					<span>
						<app-icon
							class="button-icon"
							[name]="'folder'"
							[color]="'var(--color-white)'"
							[lineWidth]="'1.5px'"
						></app-icon>
						<span class="text-spacing">PAYMENT ORDERS</span>
						<app-icon
							class="arrow-icon arrow-down"
							[name]="'arrow-down'"
							[color]="'var(--color-white)'"
							[lineWidth]="'1.5px'"
							[ngClass]="{ 'arrow-up': paymentOrderDropdown }"
						></app-icon>
					</span>
				</button>

				<ng-template #menu>
					<div class="payment-orders-sub-menu" cdkMenu>
						<button
							id="uploadG2NButton"
							class="sub-menu"
							cdkMenuItem
							(click)="fileClick()"
							[attr.data-test]="'upload-g2n-button'"
							[disabled]="!isEnabledG2NFileUpload"
						>
							<span class="items">
								<app-icon
									class="button-icon"
									[name]="isEnabledG2NFileUpload ? 'document-upload' : 'document-upload-disabled'"
									[color]="'var(--color-upload-button-dark-grey)'"
									[lineWidth]="'1.5px'"
									[size]="'24'"
								></app-icon>
								<span class="text">Upload G2N File</span>
							</span>
						</button>
						<button
							id="cpnDeductionUploadButton"
							class="sub-menu"
							cdkMenuItem
							(click)="uploadCPNDeductionFile()"
							[attr.data-test]="'upload-cpn-deduction-file-button'"
							[disabled]="!isEnabledCPNDeductionUpload"
						>
							<span class="items">
								<app-icon
									class="button-icon"
									[name]="
										isEnabledCPNDeductionUpload ? 'document-upload' : 'document-upload-disabled'
									"
									[color]="'var(--color-upload-button-dark-grey)'"
									[lineWidth]="'1.5px'"
									[size]="'24'"
								></app-icon>
								<span class="text">Upload CP App Deductions</span>
							</span>
						</button>
					</div>
				</ng-template>
				}
			</ng-template>
		</div>
	</div>
	<div
		class="table-header-g2n"
		[ngClass]="
			isPaymentDeductionEnabled
				? 'with-deductions'
				: !isPaymentDeductionEnabled && hasFailedOrErrorFile
				? 'with-no-deductions-errors'
				: ''
		"
	>
		<div id="date" class="table-header-item">DATE</div>
		<div id="name" class="table-header-item">FILE NAME</div>
		<div id="type" class="table-header-item">FILE TYPE</div>
		<div id="status" class="table-header-item">STATUS</div>
		<div id="validation" class="table-header-item">VALIDATION</div>
		<div id="task" class="table-header-item">TASK</div>
		<div id="detail" class="table-header-item"></div>
		<div id="download" class="table-header-item"></div>
	</div>

	@let files = history$ | async; @if(files) {
	<ng-container class="table-body">
		@if(!files.length) {
		<div>
			<no-items-layout message="No files have been uploaded"></no-items-layout>
		</div>
		} @for(file of files; track $index; let i = $index) {
		<div
			[ngClass]="{
				'active-list-item': file.status === 'FAILED'
			}"
			class="data-row row-item-section"
		>
			@if(file.taskId){
			<div
				class="table-body"
				[ngClass]="{
					setOpacity: i > lastResetIndex,
					'with-deductions': !!isPaymentDeductionEnabled,
					'with-no-deductions-errors': !isPaymentDeductionEnabled && hasFailedOrErrorFile
				}"
			>
				<div class="table-row-item" id="dateCell">
					{{ file.createdAt | date : "mediumDate" }}
				</div>

				<div
					[matTooltip]="isXlsxFile(file.fileName!) ? file.fileName! : '-'"
					[matTooltipPosition]="'above'"
					[matTooltipClass]="'file-mgt-table-tooltip'"
					class="table-row-item"
					id="nameCell"
				>
					{{ isXlsxFile(file.fileName!) ? file.fileName : "-" }}
				</div>

				<div
					[matTooltip]="file.fileType!"
					[matTooltipPosition]="'above'"
					[matTooltipClass]="'file-mgt-table-tooltip'"
					class="table-row-item"
					id="type-cell"
				>
					{{
						isXlsxFile(file.fileName!)
							? file.fileType! === "DEDUCTIONS"
								? "DEDUCTIONS"
								: "G2N"
							: "Payroll Integration"
					}}
				</div>
				<div
					class="table-row-item"
					id="statusCell"
					[matTooltip]="file.status!"
					[matTooltipPosition]="'above'"
					[matTooltipClass]="'file-mgt-table-tooltip'"
					[ngClass]="{
						'status-green': file.status === 'SUCCESS',
						'status-red': file.status === 'FAILED' || file.status === 'ERROR',
						'status-pending': file.status === 'PENDING'
					}"
					[attr.data-test]="'file-history-item-status-text'"
				>
					{{ file.status! | fileStatus }}
				</div>
				@if(file?.attributes && file.attributes!['NET_HANDSHAKE'] &&
				Object.keys(file.attributes!['NET_HANDSHAKE']).length) {
				<div class="table-row-item validation-icon">
					@if(file.attributes!['NET_HANDSHAKE'].status === 'COMPLETED' &&
					file.attributes!['NET_HANDSHAKE'].allMatch) {
					<app-icon
						[name]="'tick-circle'"
						[color]="'#287d3c'"
						id="tickCircle"
						[matTooltip]="'The validation was successful'"
						[matTooltipPosition]="'above'"
						[matTooltipClass]="'sucess-integration'"
					></app-icon>
					} @else if(file.attributes!['NET_HANDSHAKE'].status === 'ERROR' ||
					!file.attributes!['NET_HANDSHAKE'].allMatch) {
					<app-icon
						[name]="'close-circle'"
						[color]="'#DA1414'"
						id="closeCircle"
						[matTooltip]="'There was an error with the validation'"
						[matTooltipPosition]="'above'"
						[matTooltipClass]="'error-integration'"
					></app-icon>
					}
				</div>
				} @else {
				<div class="table-row-item validation-icon">
					<span class="no-file-attribute">-</span>
				</div>
				} @if(isPaymentDeductionEnabled || (!isPaymentDeductionEnabled && (hasFailedOrErrorFile ||
				file.attributes!['NET_HANDSHAKE']?.status === 'ERROR' || !file.attributes!['NET_HANDSHAKE']?.allMatch)))
				{
				<div class="table-row-item" id="taskCell">
					@if(isTaskComplete(file)) {
					<div class="task-completed">
						<span>Completed</span>
						<app-icon
							class="icon"
							name="tick"
							[lineWidth]="'1.5px'"
							[size]="'24'"
							[color]="'var(--complete-color)'"
						></app-icon>
					</div>
					} @else {
					<button
						class="task-mark-complete-button"
						[ngClass]="{ active: i <= lastResetIndex }"
						[disabled]="i > lastResetIndex"
						(click)="markTaskComplete(file.taskId)"
					>
						<span class="text">Mark as completed</span>
					</button>
					}
				</div>
				}

				<div id="detailCell" class="table-row-item">
					@let net = file?.attributes?.['NET_HANDSHAKE']; @if (( (file?.status === 'FAILED' || file?.status
					=== 'ERROR') && !!file?.taskId ) || ( net && Object.keys(net).length > 0 && net.status === 'ERROR' )
					|| ( net && !!net?.results?.length && net?.allMatch === false )) {
					<app-icon
						[name]="'eye'"
						id="eyeIcon"
						[matTooltip]="'Detail'"
						[matTooltipPosition]="'above'"
						[matTooltipClass]="'file-mgt-table-tooltip'"
						(click)="viewErrors(file)"
					></app-icon>
					}
				</div>
				<div id="downloadCell" class="table-row-item">
					@if(file.status !== 'PENDING' && file?.fileId) {
					<app-icon
						[name]="'document-download'"
						id="downloadIcon"
						[matTooltip]="'Download'"
						[matTooltipPosition]="'above'"
						[matTooltipClass]="'file-mgt-table-tooltip'"
						class="material-icons-outlined"
						(click)="downloadFile(file.fileId!, file.fileName!)"
					></app-icon>
					}
				</div>
			</div>
			} @else if(file.userReset) {
			<div class="data-row run-reset" fxLayoutAlign="center center">
				<span class="run-reset-text" fxFlexAlign="center start"
					>RUN HAS BEEN RESET LAST {{ file.createdAt | date : "MMMM" | uppercase }}
					{{ file.createdAt | date : "d" }}
					<div id="positionUserReset" class="position">{{ file.createdAt | date : "d" | datePosition }}</div>
					&nbsp;BY {{ file.userReset | userFullName | async | uppercase }}</span
				>
			</div>
			} @else if(file.userCancelled) {
			<div class="data-row run-reset" fxLayoutAlign="center center">
				<span class="run-reset-text" fxFlexAlign="center start"
					>RUN HAS BEEN CANCELLED LAST {{ file.createdAt | date : "MMMM" | uppercase }}
					{{ file.createdAt | date : "d" }}
					<div id="positionUserCancel" class="position">{{ file.createdAt | date : "d" | datePosition }}</div>
					&nbsp;BY {{ file.userCancelled | userFullName | async | uppercase }}</span
				>
			</div>
			}
		</div>
		}
	</ng-container>
	} @else {
	<div class="pulsate loader">Fetching files...</div>
	}
</div>
